import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as axe from 'axe-core';
import styles from "./styles.module.scss";
import { Accordion, Divider, Flex, Input, Select, Space, Text, Title, Tooltip } from '@mantine/core';
import { AutomatedAuditLoader, Button, Textarea, TextInput } from '@common/components';
import { CodeBlock, dracula, CopyBlock } from 'react-code-blocks';
import { ArrowUp, Globe, Paperclip } from '@geist-ui/icons';
import { useMediaQuery } from '@mantine/hooks';
import { auditCodeSnippet, codeSnippetCheckerH, codeSnippetCheckerI, fetchLatestReportRetry, useAppDispatch, useAppSelector } from 'src/store';
import { shallowEqual } from 'react-redux';
import { Table } from 'src/components';
import { Link } from 'react-router-dom';
import { checkValidHttps } from '@common/helpers/checkValidHttps';

interface Issue {
    id: string;
    description: string;
    impact: string;
    help: string;
}

const CodeAccessibilityChecker: React.FC = () => {
    const [url, setUrl] = useState('');
    const [codeSnippet, setCodeSnippet] = useState('');
    // const [issues, setIssues] = useState<Issue[]>([]);
    const { loadingauditCodeSnippet, codeSnippetCheckerData,codeSnippetChecker, auditCodeSnippetData,  } = useAppSelector((state) => state.tools, shallowEqual);
    // const { mapData,latestReport,trackingNumber,reportId } = useAppSelector((state) => state.automatedReports, shallowEqual); 
    const dispatch = useAppDispatch();

    const checkSnippetAccessibility = () => {        
        if (!codeSnippet) return;
        setshowNewResults(true);

        dispatch(auditCodeSnippet({ htmlSnippet : codeSnippet,auditStandard:selectedStandard,domainName:url }));
    };
    const [language, changeLanguage] = useState("jsx");
    const isMobile = useMediaQuery('(max-width: 991px)');
    const auditStandards: any = [
        'WCAG 2.1A',
        'WCAG 2.1AA',
        'WCAG 2.1AAA'
    ];
    const [previousAudits, setPreviousAudits] = useState([]);
    const [ selectPrevSite , setSelectPrevSite ] = useState("")

    const [ selectedStandard , setSelectedStandard ] = useState("A")

        useEffect(() => {
            dispatch(codeSnippetCheckerI({}));
        
        }, [])

          useEffect(() => {
            
                if (!codeSnippetCheckerData || !Array.isArray(codeSnippetCheckerData)) {
                  return;
                }
              
                const formattedData:any = codeSnippetCheckerData?.map((item: any) => ({
                  value: item.id,
                  label: item.domainName,
                }));
              
                setPreviousAudits(formattedData);
              }, [codeSnippetCheckerData]);
              

    const [showNewResults, setshowNewResults] = useState(true)
    return (
        <div style={{ backgroundColor: '#F5F7FA', width: 'calc(100% - 300px)' }}>

            <div className={styles.container_bg}>
                <Flex justify={'space-between'} direction={isMobile ? 'column' : 'row'}>
                    <Flex align={"center"} gap={"sm"}>
                        <Title order={1} id={'mainContent'} color="#264547" className={styles.heading}>
                            Code Snippet Accessibility Checker
                        </Title>
                    </Flex>
                </Flex>
                <Space h={"md"} />
                <Divider />
                <Space h={"md"} />
                <Flex justify={'space-between'} direction={isMobile ? 'column' : 'row'}>
                    <Flex align={"center"} gap={"sm"}>
                    <Select
                            disabled={loadingauditCodeSnippet}
                            label="Select Audit Standard"
                            placeholder="Choose standard"
                            value={`WCAG 2.1${selectedStandard}`}
                            onChange={(e) => {
                                if (e) {
                                    const level = e.replace('WCAG 2.1', ''); // remove "WCAG 2.1"
                                    setSelectedStandard(level.trim());       // trim spaces and set only "A", "AA", or "AAA"
                                  }
                            }}
                            data={auditStandards}
                            className={styles.auditDropdown}
                        />

                         <Select
                                disabled={loadingauditCodeSnippet}
                                label="Choose Previous Audits"
                                placeholder="Previous Audits"
                                value={selectPrevSite}
                                onChange={(e) => {
                                    if ( !e ) return;
                                    setshowNewResults(false);
                                    setSelectPrevSite(e)
                                    dispatch(codeSnippetCheckerH({ snippetId : e }));
                                }}
                                data={previousAudits}
                                className={styles.auditDropdown}
                            />
                    </Flex>
                </Flex>


                <Space h={"md"} />
            </div>
            {/* <div className={styles.checkercontainer}>
                  <div className={styles.snippetchecker}>
                    <textarea
                          placeholder="Your Code Snippet"
                        rows={6}
                        onChange={(e) => setCodeSnippet(e.target.value)}
                    />
                    <Button onClick={checkSnippetAccessibility} disabled={!codeSnippet || loading} >
                        <ArrowUp className={styles.icon} />
                    </Button> 
                </div>
                

                {loading && <p>Checking for Accessibility Issues...</p>}
                { 
                    <div className={styles.resultssection}>
                        <h3>WCAG Issues Found</h3>
                        {issues.length > 0 ? (
                            <ul>
                                <Accordion
                                    chevronPosition="left" 
                                    variant="separated"
                                    defaultValue="Settings"
                                    classNames={{ chevron: styles.chevron }}
                                    radius={'lg'}
                                    multiple={false}
                                    >
                                    {issues.map((issue) => (
                                                <Accordion.Item value={issue.id}>
                                                    <Accordion.Control style={{ backgroundColor:"#f5f7fa"}}>
                                                        <strong>{issue.impact?.toUpperCase()}</strong>: {issue.description}
                                                    </Accordion.Control>
                                                    <Accordion.Panel style={{ backgroundColor:"#f5f7fa"}}>
                                                    <div style={{ paddingLeft: "20px" }}>
                                                        <p>Help: {' '}</p>
                                                        <p dangerouslySetInnerHTML={{ __html: issue.help }}></p>

                                                    </div>
                                                    </Accordion.Panel>
                                                </Accordion.Item>
                                       
                                    ))}
                                </Accordion>
                            </ul>
                        ) : (
                            <p>No issues found or ready to check a page.</p>
                        )}
                    </div>
                }
            </div> */}

            <div className={styles.container}>
                    <TextInput
                        error={ url && checkValidHttps(url) ? null : 'Enter the full URL of the website. Example: https://vially.io/ '}                   
                        className={styles.wFull}
                        label='Domain Url'
                        placeholder='Domain Url here ...'
                        autoFocus={true}
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        required
                        disabled={ loadingauditCodeSnippet }
                    />
                <Space h={"sm"} />
                <textarea
                    disabled={ loadingauditCodeSnippet }
                    value={codeSnippet}
                    placeholder="Your Code Snippet"
                    rows={8}
                    onChange={(e) => setCodeSnippet(e.target.value)}
                    className={styles.textarea}
                />
                <Button
                    disabled={ !codeSnippet || !checkValidHttps(url) || loadingauditCodeSnippet}
                    onClick={ () => checkSnippetAccessibility()} className={styles.button} >
                    Audit Code
                </Button>

                {loadingauditCodeSnippet && (
                        <>  
                            <Space h={"sm"} />
                            <AutomatedAuditLoader />
                            <Text>Looking For Issues</Text>
                        </>
                    )}
                  
            </div>

            <div > 
            <Space h={"sm"} />
            {/* <div className={styles.wrraper}>
                <WebsitesListComponent />
            </div> */}
            {    
            ( !!auditCodeSnippetData?.length && !loadingauditCodeSnippet && showNewResults ) && <Table showReAudit={false} report={auditCodeSnippetData}></Table>
            ||
            (codeSnippetChecker?.length > 0)  && <Table showReAudit={false}   report={codeSnippetChecker}></Table>
            }
            </div>
        </div>
    );
};

export default CodeAccessibilityChecker;


function WebsitesListComponent() {
    const initialWebsites: any[] = [
        { name: 'Google', url: 'https://www.google.com', icon: 'https://www.google.com/favicon.ico', date : '11/11/2024'},
        { name: 'Facebook', url: 'https://www.facebook.com', icon: 'https://www.facebook.com/favicon.ico', date : '10/09/2024'},
        { name: 'Twitter', url: 'https://www.twitter.com', icon: 'https://www.twitter.com/favicon.ico', date : '11/11/2024'},
        { name: 'Twitter', url: 'https://www.twitter.com', icon: 'https://www.twitter.com/favicon.ico', date : '10/09/2024'},

    ];
    return (

        <>
        {
        initialWebsites.map((website, index) => (
            <Link className={styles.prevsiteContainer} to={"#"}>
                <Flex direction={"column"} >
                    <Text weight={500}> Audit Date : {website.date}</Text>
                    <Text size="sm" color="dimmed">
                        URL: {website.url}
                    </Text>
                    
                </Flex>
                <img
                    src={website.icon}
                    alt={website.name}
                    width="20"
                    height="20"
                    style={{ borderRadius: '50%' }}
                />
            </Link>

        ))
}
        </>
    );
}
